import { render, staticRenderFns } from "./LocationBaseData.vue?vue&type=template&id=188b6ebe"
import script from "./LocationBaseData.vue?vue&type=script&lang=js"
export * from "./LocationBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports